<template>
  <div :class="[gridLayoutCssClass, `text-${textAlign}`]">
    <template v-for="(content, index) in blokContent" :key="content?._uid || index">
      <div class="grid__content">
        <slot :content="content" :index="index"></slot>
      </div>
    </template>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { TextAlignTypes } from '../../../constants/enums'

const props = defineProps({
  blokContent: {
    type: Array,
    required: true,
    default: () => {
      return []
    },
  },
  textAlign: {
    type: String,
    default: 'left',
    validator: (value) => TextAlignTypes.includes(value),
  },
})

const gridLayoutCssClass = computed(() => {
  if (props.blokContent?.length) {
    if (props.blokContent.length % 7 === 0) {
      return 'grid grid--layout-7'
    }
    if (props.blokContent.length % 5 === 0) {
      return 'grid grid--layout-5'
    }
    if (props.blokContent.length % 3 === 0) {
      return 'grid grid--layout-3'
    }
    if (props.blokContent.length % 2 === 0) {
      return 'grid grid--layout-2'
    }
    if (props.blokContent.length === 1) {
      return 'grid grid--layout-1'
    }
  }
  return 'grid grid--layout-3'
})
</script>

<style scoped lang='scss'>
.grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 1rem;
  align-items: stretch;
  margin-inline: auto;
  width: 100%;
  justify-content: v-bind('props.textAlign');
  margin-block: 1rem;

  &__content {
    display: flex;
    width: 100%;

  &:deep(> *) {
      margin-block: 0;
    }
  }

  &--layout {
    &-3 .grid__content,
    &-5 .grid__content,
    &-7 .grid__content:is(:nth-child(7n + 3), :nth-child(7n + 4), :nth-child(7n + 5)) {
      grid-column: span 2;
    }

    &-2 .grid__content,
    &-5 .grid__content:is(:nth-child(5n + 4), :nth-child(5n + 5)),
    &-7 .grid__content {
      grid-column: span 3;
    }

    &-1 .grid__content {
      grid-column: 1 / -1;
    }
  }

  @media (width <= 810px) {
    display: flex;
    flex-wrap: wrap;

    .grid__content {
      flex-basis: 100%;
    }
  }
}
</style>
